module.exports = __webpack_public_path__ + "static/STQBcert-d73190b4300bda3ed3ebd1218a74b6e8.jpg";